export default __webpack_public_path__ + "static/media/quality.83d7e91d.png";